<template>
    <div class="registrar-container">
        <Message :message="message" :type="type" v-if="message!==''"></Message>
        <UserAccount :title="title" :user="user" @cancel="handleCancel" @save="handleSave" @setMessage="setMessage"
                     form-mode="register" v-if="loaded"></UserAccount>
        <Preloader v-else></Preloader>
    </div>
</template>

<script>
import UserAccount from '@/components/UserAccount.vue';
import Message from '@/components/helpers/Message.vue';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import { UserExistsError } from '@/api/user/erros';
import Preloader from '@/components/helpers/Preloader';

const UserRepository = RepositoryFactory.get('users');
export default {
  name: 'RegisterUser',
  components: {
    Preloader,
    Message,
    UserAccount,
  },
  data() {
    return {
      title: this.$t('registerUser'),
      message: '',
      type: 'info',
      loaded: true,
    };
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleSave(user) {
      this.loaded = false;
      const { token } = this.$store.getters;
      UserRepository.registerUser(user, token).then(() => {
        this.message = this.$t('messages.registerUser');
        this.type = 'info';
        this.loaded = true;
      }).catch((e) => {
        if (e instanceof UserExistsError) {
          this.message = this.$t('messages.userExists');
        } else {
          this.message = this.$t('errors.genericError');
        }
        this.type = 'error';
        this.loaded = true;
      });
    },
    handleCancel() {
      this.$router.push('/administration/users');
    },
    setMessage(message) {
      this.message = message.message;
      this.type = message.type;
    },
  },
};
</script>

<style scoped lang="scss">
    .registrar-container {
        width: 100%;
    }
</style>
